// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu_menu__6sfuw {
  height: 75px;
  padding: 20px;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: var(--tg-theme-bg-color);
  z-index: 100;
}

.menu_link__KmZ0f {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 400;
  font-size: 10px;
  color: var(--icon-color);
  line-height: 12px;
  position: relative;
  --icon-color: #DEDEDE;
}
.menu_link__KmZ0f.menu_active__sdbmA {
  color: var(--tg-theme-button-color);
}
.menu_link__KmZ0f.menu_active__sdbmA svg {
  fill: var(--accent-color);
}

.menu_text__bCpXR {
  margin-top: 8px;
}

.menu_label__R7idf {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--tg-theme-button-color);
  color: var(--tg-theme-text-color);
  border-radius: 50%;
  position: absolute;
  top: -20%;
  left: 50%;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/entities/menu/menu.module.scss"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,0CAAA;EACA,YAAA;AAAF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;AADF;AAGE;EACE,mCAAA;AADJ;AAGI;EACE,yBAAA;AADN;;AAMA;EACE,eAAA;AAHF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;EACA,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;AAJF","sourcesContent":["\n.menu {\n  height: 75px;\n  padding: 20px;\n  width: 100%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  background-color: var(--tg-theme-bg-color);\n  z-index: 100;\n\n}\n\n.link {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-weight: 400;\n  font-size: 10px;\n  color: var(--icon-color);\n  line-height: 12px;\n  position: relative;\n  --icon-color: #DEDEDE;\n\n  &.active {\n    color: var(--tg-theme-button-color);\n\n    svg {\n      fill: var(--accent-color)\n    }\n  }\n}\n\n.text {\n  margin-top: 8px;\n\n}\n\n.label {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--tg-theme-button-color);\n  color: var(--tg-theme-text-color);\n  border-radius: 50%;\n  position: absolute;\n  top: -20%;\n  left: 50%;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `menu_menu__6sfuw`,
	"link": `menu_link__KmZ0f`,
	"active": `menu_active__sdbmA`,
	"text": `menu_text__bCpXR`,
	"label": `menu_label__R7idf`
};
export default ___CSS_LOADER_EXPORT___;
